import $ from 'jquery';
import 'bootstrap';
import Swiper, {Navigation, Pagination} from 'swiper';
import Marquee3k from 'marquee3000';
import Masonry from 'masonry-layout'
Swiper.use([Navigation, Pagination]);
require('waypoints/lib/noframework.waypoints.js');
import AOS from 'aos';

const animateCSS = (element, animation, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const node = document.querySelector(element);

        node.classList.add(`${prefix}animated`, animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd() {
            node.classList.remove(`${prefix}animated`, animationName);
            resolve('Animation ended');
        }

        node.addEventListener('animationend', handleAnimationEnd, {once: true});
    })
;


const general = {
    "mqBreakpoints": {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1156
    },

    handleListingGrid: function() {
        if ($('.grid').length){
            var msnry = new Masonry( '.grid', {
                columnWidth: '.grid-sizer',
                itemSelector: '.grid-item',
                percentPosition: true
            });
        }
    },

    handleMap: function() {
        let $shops = $('#js-shops-coordinates');

        if (!$shops.length) {
            return;
        }

        try {
            $shops = JSON.parse($shops.text());

            let script = document.createElement('script');
            let map;

             // script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCn5jUQe35M5-YdYZx-o8zB0Hu1xDCyARM&callback=initMap';
            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDCBeqasUXo6APtAU7hSYMP_eFdRPoaIrQ&callback=initMap';
            script.defer = true;

            window.initMap = function() {
                const restaurant = { lat: 49.6360957, lng: 6.1375866 };
                // The map, centered at Uluru
                map = new google.maps.Map(document.getElementById("map"), {
                    zoom: 11,
                    center: restaurant,
                });

                var marker = [];

                Object.keys($shops).forEach($key => {

                    marker[$key] = new google.maps.Marker({
                        position: new google.maps.LatLng($shops[$key].lat, $shops[$key].lon),
                        map: map,
                        icon: '/wp-content/themes/intrepide/static/img/dark_pin.svg'
                    });

                    marker[$key]
                        .addListener('click', function() {
                            let activeShopItem = document.querySelector('.js-shop-item.-active');
                            if (activeShopItem !== null) {
                                document.querySelector('.shops__list').classList.add('-open');
                                document.querySelector('.js-shop-item.-active').classList.remove('-active');
                            }
                            document.querySelector('.js-shop-item[data-shopid="'+$key+'"] .stretched-link').click();

                            Object.keys($shops).forEach($key => {
                                marker[$key].setIcon('/wp-content/themes/intrepide/static/img/black_pin.svg');
                            });
                            this.setIcon('/wp-content/themes/intrepide/static/img/brown_pin.svg');
                        });

                    marker[$key]
                        .addListener('mouseover', function() {
                            document.getElementById("cursor2").classList.add('hover');
                        });

                    marker[$key]
                        .addListener('mouseout', function() {
                            document.getElementById("cursor2").classList.remove('hover');
                        });

                    marker[$key]
                        .addListener('dblclick', function() {
                            Object.keys($shops).forEach($key => {
                                marker[$key].setIcon('/wp-content/themes/intrepide/static/img/black_pin.svg');
                            });
                            this.setIcon('/wp-content/themes/intrepide/static/img/brown_pin.svg');
                        });
                });

                const styledMapType = new google.maps.StyledMapType(
                    [
                        {
                            "featureType": "administrative",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#444444"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": 45
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "simplified"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit.line",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "on"
                                }
                            ]
                        },
                        {
                            "featureType": "transit.station",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "on"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#BF9474"
                                },
                                {
                                    "visibility": "on"
                                }
                            ]
                        }
                    ]

                );

                const buttonsShop = document.querySelectorAll('.js-shop-toggler');
                buttonsShop.forEach($button => $button.addEventListener('click', (event) => {
                    const button = event.currentTarget;
                    const parent = button.parentNode;
                    google.maps.event.trigger(marker[parent.dataset.shopid], 'dblclick');
                }));

                map.mapTypes.set("styled_map", styledMapType);
                map.setMapTypeId("styled_map");
            }

            document.head.appendChild(script);
        } catch (err) { // invalid json
            return;
        }
    },

    handleShops: function() {

        const buttonsOpen = document.querySelectorAll('.js-shops-opening');
        const buttonClose = document.querySelector('.js-shops-closing');

        buttonsOpen.forEach($button => $button.addEventListener('click', (event) => {
            const panel = document.querySelector('#shops');
            panel.classList.remove('animate__animated', 'animate__fadeOutRight', 'animate__fadeInRight')
            panel.classList.add('animate__animated', 'animate__fadeInRight')
            document.querySelector('body').classList.add('js-menu-open');
        }));

        buttonClose.addEventListener('click', () => {
            const panel = document.querySelector('#shops');
            panel.classList.add('animate__animated', 'animate__fadeOutRight');
            document.querySelector('body').classList.remove('js-menu-open');
        });

        const buttonsShop = document.querySelectorAll('.js-shop-toggler');

        buttonsShop.forEach($button => $button.addEventListener('click', (event) => {
            const button = event.currentTarget;
            const parent = button.parentNode;
            const parentSelector = 'div[data-shopid="'+parent.dataset.shopid+'"]';

            google.maps.events

            if (!parent.classList.contains('-active')) {
                animateCSS('.shops__list', 'fadeOut')
                    .then(
                        () => {
                            parent.classList.add('-active');
                            document.querySelector('.shops__list').classList.add('-open');
                            animateCSS(parentSelector, 'fadeIn');
                        }
                    );
            } else {
                animateCSS(parentSelector, 'fadeOut')
                    .then(
                        () => {
                            parent.classList.remove('-active');
                            document.querySelector('.shops__list').classList.remove('-open');
                            animateCSS('.shops__list', 'fadeIn');
                        }
                    );
            }
        }));
    },

    handleMouseMoving: function () {
        var e = document.getElementById("cursor2");

        document.getElementsByTagName("body")[0].addEventListener("mousemove", function(n) {
            e.style.left = n.clientX + "px",
                e.style.top = n.clientY + "px"
        });

        function n(t) {
            e.classList.add("hover")
        }

        function s(t) {
            e.classList.remove("hover")
        }

        function o(t) {
            t.addEventListener("mouseover", n), t.addEventListener("mouseout", s)
        }

        s();
        $('body').on('mouseover', 'a', function() {n()});
        $('body').on('mouseout', 'a', function() {s()});

        $('body').on('mouseover', '.js-hover-effect', function() {n()});
        $('body').on('mouseout', '.js-hover-effect', function() {s()});

        $('body').on('mouseover', '[type="submit"]', function() {n()});
        $('body').on('mouseout', '[type="submit"]', function() {s()});


        // for (var r = document.querySelectorAll("a"), a = r.length - 1; a >= 0; a--) {
        //     o(r[a])
        // }
        //
        // for (var r = document.querySelectorAll(".js-hover-effect"), a = r.length - 1; a >= 0; a--) {
        //     o(r[a])
        // }
        //
        // for (var r = document.querySelectorAll("[type='submit']"), a = r.length - 1; a >= 0; a--) {
        //     o(r[a])
        // }
    },

    handleMarkee3k: function() {
        if ($('.marquee3k').length) {
            Marquee3k.init({
                selector: 'marquee3k',
            });
        }
    },

    handleSwiper: function() {
        var HomeSwiper = new Swiper('.swiper-home', {
            speed: 400,
            spaceBetween: 100,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            loop: true,
        });

        var footerSwiper = new Swiper('.swiper-footer', {
            spaceBetween: 0,
            slidesPerView: 2,
            breakpoints: {
                320: {
                    slidesPerView: 1.5,
                },
                1200: {
                    slidesPerView: 2.5,
                },
            },
        });
    },

    handleHomeAnimation: function() {
        const windowHeight = window.innerHeight;
        let yPxTrigger, yPercentTrigger;

        // Triggering on scroll
        if ($('.home').length) {
            const triggerAnimation = [
                {
                    id: 'title-fresh',
                    offsetTop: (0.5 * window.innerHeight),
                    revert: false,
                    handler: function handler (direction) {
                        if (direction === 'down') {
                            document.getElementById('title-fresh').classList.add('-active');
                        } else {
                            document.getElementById('title-fresh').classList.remove('-active');
                        }
                    }
                },
                {
                    id: 'title-traitor',
                    offsetTop: (0.5 * window.innerHeight),
                    revert: false,
                    handler: function (direction) {
                        if (direction === 'down') {
                            document.getElementById('title-traitor').classList.add('-active');
                        } else {
                            document.getElementById('title-traitor').classList.remove('-active');
                        }
                    }
                },
                // Circuit court
                {
                    id: 'cc',
                    offsetTop: (1 * window.innerHeight),
                    revert: false,
                    handler: function (direction) {
                        if (direction === 'down') {
                            document.getElementById('cc').classList.add('-active');
                            document.getElementById('cc__svg').classList.add('-active');
                            document.getElementById('cc').classList.add('animate__animated');
                            document.getElementById('cc').classList.add('animate__fadeInRight');
                        }
                    }
                },
                {
                    id: 'cc',
                    revert: true,
                    handler: function (direction) {
                        if (direction !== 'down') {
                            document.getElementById('cc').classList.remove('animate__animated');
                            document.getElementById('cc').classList.remove('animate__fadeInRight');
                            document.getElementById('cc').classList.remove('-active');
                            document.getElementById('cc__svg').classList.remove('-active');
                        }
                    }
                },
                // Since
                {
                    id: 'since',
                    offsetTop: (1 * window.innerHeight),
                    revert: false,
                    handler: function (direction) {
                        if (direction === 'down') {
                            document.getElementById('since').classList.add('-active');
                            document.getElementById('since').classList.add('animate__animated');
                            document.getElementById('since').classList.add('animate__fadeInLeft');
                        }
                    }
                },
                {
                    id: 'since',
                    revert: true,
                    handler: function (direction) {
                        if (direction !== 'down') {
                            document.getElementById('since').classList.remove('animate__animated');
                            document.getElementById('since').classList.remove('animate__fadeInLeft');
                            document.getElementById('since').classList.remove('-active');
                        }
                    }
                },
                {
                    id: 'newsletter',
                    offsetTop: (0.75 * window.innerHeight),
                    revert: false,
                    handler: function (direction) {
                        if (direction === 'down') {
                            document.getElementById('newsletter').classList.add('animate__animated');
                            document.getElementById('newsletter').classList.add('animate__fadeIn');
                            document.getElementById('newsletter').classList.add('-active');
                        }
                    }
                },
                {
                    id: 'newsletter',
                    revert: true,
                    handler: function (direction) {
                        if (direction !== 'down') {
                            document.getElementById('newsletter').classList.remove('animate__animated');
                            document.getElementById('newsletter').classList.remove('animate__fadeIn');
                            document.getElementById('newsletter').classList.remove('-active');
                        }
                    }
                },
                {
                    id: 'gallery',
                    offsetTop: (0.75 * window.innerHeight),
                    revert: false,
                    handler: function (direction) {
                        if (direction === 'down') {
                            document.getElementById('gallery').classList.add('animate__animated');
                            document.getElementById('gallery').classList.add('animate__fadeIn');
                            document.getElementById('gallery').classList.add('-active');
                        }
                    }
                },
                {
                    id: 'footer',
                    offsetTop: (1 * window.innerHeight),
                    revert: false,
                    handler: function (direction) {
                        if (direction === 'down') {
                            document.getElementById('home-news').classList.add('-hidden');
                        }
                    }
                },
                {
                    id: 'home-news',
                    offsetTop: (.75 * window.innerHeight),
                    revert: false,
                    handler: function (direction) {
                        if (direction === 'down') {
                            document.getElementById('home-news').classList.add('animate__fadeOutRight');
                            document.getElementById('home-news').classList.remove('animate__fadeInRight');
                        }
                    }
                },
                {
                    id: 'home-news',
                    offsetTop: (.75 * window.innerHeight),
                    revert: true,
                    handler: function (direction) {
                        if (direction !== 'down') {
                            document.getElementById('home-news').classList.remove('animate__fadeOutRight');
                            document.getElementById('home-news').classList.add('animate__animated');
                            document.getElementById('home-news').classList.add('animate__fadeInRight');
                        }
                    }
                },
            ];

            if ($(window).width() > general.mqBreakpoints['lg']) {
                $.each(triggerAnimation, function(key, animation) {
                    if (animation.revert === false) {
                        // Triggering with offset
                        let offsetAnim = animation.offsetTop;

                        yPxTrigger = $('#'+animation.id).offset().top - offsetAnim;
                        yPercentTrigger = '-' + Math.round(yPxTrigger / windowHeight * 100) + '%';
                    } else {
                        let offsetAnim = windowHeight;

                        // Triggering when scroll up and element hidden from screen
                        yPxTrigger = $('#'+animation.id).offset().top - offsetAnim;
                        yPercentTrigger = '-' + Math.round(yPxTrigger / windowHeight * 100) + '%';
                    }

                    window['spyscroll-animation-' + key] = new Waypoint({
                        element: document.getElementById('js-waypoint'),
                        handler: animation.handler,
                        offset: yPercentTrigger
                    });
                })
            } else {
                document.getElementById('cc').classList.add('-active');
                document.getElementById('cc__svg').classList.add('-active');
                document.getElementById('cc').classList.add('animate__animated');
                // document.getElementById('cc').classList.add('animate__fadeInRight');
                document.getElementById('since').classList.add('-active');
                document.getElementById('since').classList.add('animate__animated');
                // document.getElementById('since').classList.add('animate__fadeInLeft');
                document.getElementById('newsletter').classList.add('animate__animated');
                // document.getElementById('newsletter').classList.add('animate__fadeIn');
                document.getElementById('newsletter').classList.add('-active');
                document.getElementById('gallery').classList.add('animate__animated');
                // document.getElementById('gallery').classList.add('animate__fadeIn');
                document.getElementById('gallery').classList.add('-active');
            }
        }

        // Triggering depending time
        if ($('.home').length) {

            // Newsletter block
            $('.js-newsletter-close').on('click', function() {
                $('.hero__newsletter-block').removeClass('-active')
            })

            setTimeout(function (){
                $('.hero__newsletter-block').addClass('-active')
            }, 2000);


            $('.js-news-close').on('click', function() {
                $('#home-news').removeClass('-active')
            })

            setTimeout(function (){
                document.getElementById('home-news').classList.add('-active');
                document.getElementById('home-news').classList.add('animate__animated');
                document.getElementById('home-news').classList.add('animate__fadeInRight');
            }, 3000);
        }
    },

    handleGlobalAnimation: function() {

        const windowHeight = window.innerHeight;
        let yPxTrigger, yPercentTrigger;

        if ($('#main-nav').length && !document.getElementById('js-waypoint').classList.contains('-menu-dark')) {
            yPxTrigger = $('#main-nav').height();
            yPercentTrigger = '-' + Math.round(yPxTrigger / windowHeight * 100) + '%';

            window['main_menu'] = new Waypoint({
                element: document.getElementById('js-waypoint'),
                handler: function (direction) {
                    if (direction === 'down') {
                        document.getElementById('main-nav').classList.add('-minified');
                        document.getElementById('js-waypoint').classList.add('-menu-dark');
                    } else {
                        if (!$('#nav-icon').hasClass('open')) {
                            document.getElementById('main-nav').classList.remove('-minified');
                            document.getElementById('js-waypoint').classList.remove('-menu-dark');
                        }
                    }
                },
                offset: yPercentTrigger
            });
        }

        if ($('#main-nav').length) {
            $('#nav-icon').click(function(){
                $(this).toggleClass('open');

                let isHomePage = false;

                if ($('body').hasClass('home')) {
                    isHomePage = true;
                }

                if (!$(this).hasClass('open') && window.pageYOffset < 100 && isHomePage) {
                    document.getElementById('main-nav').classList.remove('-minified');
                    document.getElementById('js-waypoint').classList.remove('-menu-dark');
                } else {
                    document.getElementById('main-nav').classList.add('-minified');
                    document.getElementById('js-waypoint').classList.add('-menu-dark');
                }
            });
        }
    },

    handleRot13emails: function() {
        $('.js-decode-rot').each( function(count,enc) { //foreach encoded DOM element
            let encodedData = jQuery(enc).html(); //grab encoded text
            let decodedData = encodedData.replace(/[a-zA-Z]/g, function(char){ //foreach character
                return String.fromCharCode( //decode string
                    /**
                     * char is equal/less than 'Z' (i.e. a  capital letter), then compare upper case Z unicode
                     * else compare lower case Z unicode.
                     *
                     * if 'Z' unicode greater/equal than current char (i.e. char is 'Z','z' or a symbol) then
                     * return it, else transpose unicode by 26 to return decoded letter
                     *
                     * can't remember where I found this, and yes it makes my head hurt a little!
                     */
                    (char<="Z"?90:122)>=(char=char.charCodeAt(0)+13)?char:char -26
                );
            });
            $(enc).html(decodedData); // replace text
        });
    },

    handleContactLabel: function() {
        if ($('.form.-contact').length) {
            $(".wpcf7-form input")
                .focus(function() {
                    $(this).parent().siblings('label').addClass('has-value');
                })
                // blur input fields on unfocus + if has no value
                .blur(function() {
                    let text_val = $(this).val();
                    if (text_val === "") {
                        $(this).parent().siblings('label').removeClass('has-value');
                    }
                });

            $(".wpcf7-form textarea")
                .focus(function() {
                    $(this).parent().siblings('label').addClass('has-value');
                })
                // blur input fields on unfocus + if has no value
                .blur(function() {
                    let text_val = $(this).val();
                    if (text_val === "") {
                        $(this).parent().siblings('label').removeClass('has-value');
                    }
                });

            $(".wpcf7-form textarea").trigger('focus');
            $(".wpcf7-form input").trigger('focus');
        }
    },

    handleCookieBar: function() {
        $('.tplis-cl-button-accept').on('click', function() {
            $('.tplis-cl-cookies').hide();
        });
    },

    handleShopListing: function() {
        $('.js-shop-item').on('click', function() {
            $('.js-shop-item').removeClass('active');
            $(this).toggleClass('active');
        })
    },

    handleProductsLinks: function() {
        $('body').on('click', '.js-link-title', function() {
            let parent = $(this).closest('.js-shop-item');
            if (parent.hasClass('active')) {
                let link = parent.attr('data-href');
                if (typeof link !== 'undefined') {
                    window.location.href = link;
                } else {
                    console.log('no link found')
                }
            }
        });
    },

    switchVariationImage: function() {
        $(document).on('change', '.variations_form', function() {
            let variations = JSON.parse($(this).attr('data-product_variations'));
            let attributes = [];
            let allAttributesSet = true;

            $(this).find('select').each(function() {
                var value = $(this).val();
                if (value) {
                    attributes.push({
                        id: $(this).attr('name'),
                        value: value
                    });
                } else {
                    allAttributesSet = false;
                }
            });

            if (allAttributesSet) {
                let selectVariation = false;
                $.each(variations,function(key, val) {

                    let variationAttributes = []

                    $.each(val.attributes, function(keyVariation, valVariation) {
                        variationAttributes.push({
                            id: keyVariation,
                            value: valVariation
                        });
                    });

                    if (JSON.stringify(variationAttributes)===JSON.stringify(attributes)) {
                        selectVariation = val;
                    }
                });

                if (selectVariation) {
                    console.log(selectVariation);
                    if (typeof selectVariation.image.src != 'undefined') {
                        $('.product-detail__img').attr('src', selectVariation.image.src);
                    }
                    if (typeof selectVariation.variation_description != 'undefined') {
                        $('.shop-item__desc').text(selectVariation.variation_description.replace(/(<([^>]+)>)/gi, ""));
                    }
                }
            }
        } );

        $('.variations_form').trigger('change');
    },
};

export default general;

(function($){
    $(document).ready(function () {
        AOS.init();
        general.handleListingGrid();
        general.handleShops();
        general.handleMouseMoving();
        general.handleSwiper();
        general.handleHomeAnimation();
        general.handleGlobalAnimation();
        general.handleMap();
        general.handleRot13emails();
        general.handleContactLabel();
        general.handleCookieBar();
        general.handleMarkee3k();
        general.handleShopListing();
        general.handleProductsLinks();
        general.switchVariationImage();
    });

    $(document).keyup(function(e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`
            $('.navbar-toggler').trigger('click');
        }
    });
})($);
